import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js'
import React, { Component } from 'react'
import { FormattedMessage } from "react-intl"
import ActionButton from "../button/actionbutton.component.jsx"
import EventBus from "../EventBus.js"
import FormRow from "../form/row.component.jsx"
import GlobalHelper from "../GlobalHelper.jsx"

class StripeCreditCardForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            name: '',
            onSubmit: this.props.onSubmit || function () { },
            submitButtonStyle: this.props.submitButtonStyle || {},
            submitButton: this.props.submitButton || <FormattedMessage
                id="common.credit_card.confirm_label"
                defaultMessage="Confirm"
            />,
            submitButtonLoading: false,
            submitDisabled: this.props.submitDisabled || false,
            onPaymentIntentCompleted: this.props.onPaymentIntentCompleted || function () { },
            saveCard: this.props.saveCard || false,
            contactId: this.props.contactId || '',
            saveAndChargeLater: this.props.saveAndChargeLater || false,
            ignoreAuthentication: this.props.ignoreAuthentication || false,
            stripeLoaded: false,
            stripeInputsAreValid: false,
            stripeValidationError: '',
            locationId: this.props.locationId,
            acceptedCardBrands: this.props.acceptedCardBrands || [],
        }

        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.handleSubmit = this.handleSubmit.bind(this)
        this.confirmCardPayment = this.confirmCardPayment.bind(this)
        EventBus.listen(EventBus.TopicPaymentTransactionCreated, 'stripe-credit-card-form-component', this.confirmCardPayment)
    }


    componentDidMount() { }

    componentWillReceiveProps(nextProps) {
        if (!this.state.stripeLoaded && nextProps.elements) {
            let that = this
            setTimeout(() => {
                const cardElement = nextProps.elements.getElement(CardElement)
                if (cardElement) {
                    cardElement.on('change', function (event) {
                        if (event.brand === "unknown") {
                            that.setState({
                                stripeInputsAreValid: true,
                                stripeValidationError: '',
                            })
                        } else if (that.state.acceptedCardBrands?.length > 0 && !that.state.acceptedCardBrands?.includes(event.brand)) {
                            const brandLabel = GlobalHelper.getCardBrandLabelByValue(event.brand)
                            const specificMessage = <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.unsupported_card_brand_specific"
                                defaultMessage="{brand} is not accepted."
                                values={{
                                    brand: brandLabel,
                                }}
                            />
                            const genericMessage = <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.unsupported_card_brand_generic"
                                defaultMessage="This card brand is not accepted."
                            />
                            that.setState({
                                stripeInputsAreValid: false,
                                stripeValidationError: brandLabel ? specificMessage : genericMessage,
                            })
                            return
                        }

                        if (event.complete) {
                            that.setState({
                                stripeInputsAreValid: true,
                                stripeValidationError: '',
                            })
                        } else {
                            that.setState({
                                stripeInputsAreValid: false,
                                stripeValidationError: event.error ? event.error.message : '',
                            })
                        }
                    })
                }
            }, 500)
            this.setState({
                stripeLoaded: true
            })
        }

        this.setState({
            submitDisabled: nextProps.submitDisabled || false,
            saveCard: nextProps.saveCard || false,
            acceptedCardBrands: nextProps.acceptedCardBrands || [],
        })
    }

    handleSubmit(event) {
        this.setState({ submitButtonLoading: true })
        event.preventDefault()

        if (this.state.saveAndChargeLater) {
            let endpoint = this.state.contactId ? `/contacts/${this.state.contactId}/setup-save-card-on-file-intent/${this.state.locationId}` : '/accounts/billing/setup-save-card-on-file-intent'
            AppContext.getApiClient().post(endpoint, {}).then(res => {
                const cardElement = this.props.elements.getElement(CardElement)
                let payload = {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: this.state.name,
                        },
                    },
                }

                let that = this
                this.props.stripe.confirmCardSetup(res.id, payload)
                    .then(function (result) {
                        that.state.onSubmit(result, null, true, null, () => {
                            if (result.error) {
                                that.setState({
                                    submitButtonLoading: false,
                                })
                            }
                        })
                    })
            })
        } else {
            this.state.onSubmit(null, null, this.state.saveCard, null, (error) => {
                if (error) {
                    this.setState({
                        submitButtonLoading: false,
                    })
                }
            })
        }
    }

    confirmCardPayment(event) {
        let lastPayment = event.getData().payment
        let paymentIntentClientSecret = ""
        if (lastPayment.attributes.type === 'credit-card' &&
            lastPayment.attributes.integratedPayment &&
            lastPayment.attributes.integratedPayment.attributes.status === 'pending') {
            paymentIntentClientSecret = lastPayment.attributes.integratedPayment.attributes.paymentIntentClientSecret
        }

        const cardElement = this.props.elements.getElement(CardElement)
        let payload = {
            payment_method: {
                card: cardElement,
                billing_details: {
                    name: this.state.name,
                },
            },
        }

        if (this.state.saveCard) {
            payload.setup_future_usage = 'off_session'
        }

        let that = this
        this.props.stripe.confirmCardPayment(paymentIntentClientSecret, payload, { handleActions: !this.state.ignoreAuthentication })
            .then(function (result) {
                if (result.error || (result.paymentIntent.status !== 'succeeded' && that.state.ignoreAuthentication)) {
                    that.setState({
                        submitButtonLoading: false,
                    })
                } else {
                    that.setState({
                        submitButtonLoading: true,
                    })
                }
                that.state.onPaymentIntentCompleted(result)
            })
    }

    render() {
        return (
            <form>
                <FormRow
                    className={"mb-0"}
                    style={"rows"}
                    name={"cardholder-name"}
                    label={<FormattedMessage
                        id="common.credit_card.name_label"
                        defaultMessage="Cardholder name"
                    />}
                    input={<input required id={"cardholder-name"} type={"text"} className="form-control" onChange={e => {
                        this.setState({
                            name: e.target.value
                        })
                    }} />}
                />
                <FormRow
                    className={"mb-0"}
                    name={"card-details"}
                    style={"rows"}
                    label={<FormattedMessage
                        id="common.credit_card.card_details_label"
                        defaultMessage="Card details"
                    />}
                    input={<CardElement id={"card-details"} className="form-control py-2" />}
                />
                {this.props.children}
                {this.state.stripeValidationError &&
                    <div class="alert alert-danger mt-3 text-center" role="alert">
                        {this.state.stripeValidationError}
                    </div>
                }
                <div className={"row py-2 mt-2"}>
                    <div className={"col-12 col-md-6 d-flex align-items-center justify-content-start flex-wrap mb-2"}>
                        <a href={'https://stripe.com'} target={'_blank'} className={'mr-1'}>
                            <img src={'/images/powered_by_stripe.png'} width={'80px'} />
                        </a>
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <ActionButton
                            loadingTimeout={30000}
                            className="btn btn-primary w-100"
                            style={this.state.submitButtonStyle}
                            onClick={this.handleSubmit}
                            isLoading={this.state.submitButtonLoading}
                            disabled={!this.state.stripeInputsAreValid || !this.state.name || this.state.submitDisabled || this.state.submitButtonLoading}
                        >
                            {this.state.submitButton}
                        </ActionButton>
                    </div>
                </div>
            </form>
        )
    }
}


export default function InjectedStripeCreditCardForm(props) {
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <StripeCreditCardForm
                    stripe={stripe}
                    elements={elements}
                    onSubmit={props.onSubmit}
                    submitButton={props.submitButton}
                    submitButtonStyle={props.submitButtonStyle}
                    submitDisabled={props.submitDisabled}
                    children={props.children}
                    saveCard={props.saveCard}
                    onPaymentIntentCompleted={props.onPaymentIntentCompleted}
                    contactId={props.contactId}
                    saveAndChargeLater={props.saveAndChargeLater}
                    ignoreAuthentication={props.ignoreAuthentication}
                    locationId={props.locationId}
                    acceptedCardBrands={props.acceptedCardBrands}
                />
            )}
        </ElementsConsumer>
    );
}





// WEBPACK FOOTER //
// ./src/common/credit-card/stripe.component.jsx